module.exports = __webpack_public_path__ + "img/icon-bedroom.48c93f44.svg";